import React, { useEffect, useState } from 'react'
import ListadoFestivos from './ListadoFestivos'
import { apiCentrosService } from 'services/apiCentrosService';
import { useAuth } from 'context/AuthProvider';
import FiltroFestivos from './FiltroFestivos';
import FestivosAccionesRapidas from './FestivosAccionesRapidas';
import { Spinner } from 'reactstrap';

const ListadoFestivosImpl = () => {
    const {empresa} = useAuth();
    const [centros, setCentros] =useState([{id:1,nombre:"centro"}]);
    const [annoSelected, setAnnoSelected] = useState(new Date().getFullYear());
    const [centroIdSelected, setCentroIdSelected] = useState("null");
    const [loading, setLoading] = useState(false)

    const [update, setUpdate] = useState(false);


    useEffect(() => {
      const fetchData = async () =>{
        const response = await apiCentrosService.getAllCentros(empresa.id);
        setCentros(response.content)
      }
    
      fetchData();

    }, [empresa.id])
    
    const handleUpdate = () =>{
      setUpdate(!update);
    }

    return (
      <>
          <FiltroFestivos centros={centros} anno={annoSelected} annoSelected={annoSelected} setAnnoSelected={setAnnoSelected} centro={centroIdSelected} setCentroIdSelected={setCentroIdSelected} ></FiltroFestivos>

  
          {(annoSelected!=="null" && centroIdSelected!=="null") 
          ? <>
             <FestivosAccionesRapidas handleUpdate={handleUpdate} anno={annoSelected} centroId={centroIdSelected} setLoading={setLoading}></FestivosAccionesRapidas>
              { (loading) ? <Spinner color="primary">
                Loading...
              </Spinner> :  
                <ListadoFestivos anno={annoSelected} centroId={centroIdSelected} update={update}></ListadoFestivos> 
   

              }
                      </>
          :"" }
      </>
    )
}

export default ListadoFestivosImpl